import React, { useMemo, useState } from 'react';
import classNames from 'classnames/bind';
import TogglePasswordButton from 'templates/LoginPageData/components/TogglePasswordButton/TogglePasswordButton';
import Icon from 'components/Icon/Icon';
import PasswordStrengthMeter from '../PasswordStrengthMeter/PasswordStrengthMeter';
import { getPasswordStength } from 'common/helpers/valdiation';
import { SvgIcons } from 'common/consts/svgIcons';
import styles from './PasswordInput.module.scss';

type Props = {
  name?: string;
  value?: string;
  label?: string;
  error?: any;
  isValid?: boolean;
  showPassword?: boolean;
  showPasswordStrength?: boolean;
  onChange: (password: string) => void;
  onFocusOut: (event:any) => void;
};

const PasswordInput = ({
  name,
  value,
  label,
  error,
  isValid,
  showPassword,
  showPasswordStrength,
  onChange,
  onFocusOut
}: Props) => {
  const [hidePassword, setHidePassword] = useState<boolean>(true);
  const passwordStrength = useMemo(() => {
    if (value && showPasswordStrength) {
      return getPasswordStength(value);
    }
  }, [value, showPasswordStrength]);

  return (
    <>
      <div className={classNames(styles.wrapper, error && styles.hasError)}>
        <div className={styles.labelWrapper}>
          <label className={styles.label}>{label}</label>
          {showPassword && (
            <TogglePasswordButton
              isShowed={!hidePassword}
              onChange={() => setHidePassword(!hidePassword)}
              className={styles.togglePasswordBtn}
            />
          )}
        </div>
        <div className={styles.inputWrapper}>
          <input
            name={name}
            type={hidePassword ? 'password' : 'text'}
            value={value}
            className={classNames(
              styles.input,
              error && styles.hasError,
              showPasswordStrength && styles.withPasswordStrength,
            )}
            onChange={(e) => onChange(e.target.value)}
            onBlur = {(e) => onFocusOut(e)}
          />
          {error && (
            <Icon
              type={SvgIcons.ERROR}
              width={16}
              className={classNames(styles.stateIcon, styles.errorIcon)}
            />
          )}
          {isValid && (
            <Icon
              type={SvgIcons.SUCCESS}
              width={24}
              className={styles.stateIcon}
            />
          )}
          {showPasswordStrength && (
            <PasswordStrengthMeter passwordStrength={passwordStrength} />
          )}
          {error && <div className={styles.error}>{error.message}</div>}
        </div>
      </div>
    </>
  );
};

export default PasswordInput;
